import { commonChecks } from '@xhs/ozone-detector'

import generateKey from '../utils/generateKey'
import { checkRes } from '../utils/checks'
import { appVersionGte } from './version'

let callbacks

if (process.env.BROWSER) {
  callbacks = window.XHS_CALLBACKS || (window.XHS_CALLBACKS = {})
}

/*
*  Escape newline chars for being transmitted with JSON
*/
function escapeNewLineChars(valueToEscape) {
  if (typeof valueToEscape === 'string') {
    return valueToEscape.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
  }
  return valueToEscape
}

function add(method, callback, spec) {
  const key = `${method}_${generateKey()}`

  callbacks[key] = function callbackWrap(res) {
    let newRes

    // Android 5.26.1 之前客户端调用 JS 会使用 JSON string 的方式
    // Android 5.26.1 开始客户端直接传递 JS object，前端不应对数据做 parse 的操作
    if (commonChecks.isIOS || appVersionGte('5.26.1')) {
      newRes = res
    } else {
      try {
        newRes = JSON.parse(escapeNewLineChars(res))
      } catch (e) {
        newRes = res
      }
    }

    if (spec?.resT) {
      checkRes(newRes, spec.resT, method)
    }

    callback(newRes)
  }

  return `XHS_CALLBACKS.${key}`
}

export default {
  add,
}
